import { render, staticRenderFns } from "./podium.vue?vue&type=template&id=601ba50b"
import script from "./podium.vue?vue&type=script&lang=js"
export * from "./podium.vue?vue&type=script&lang=js"
import style0 from "./podium.vue?vue&type=style&index=0&id=601ba50b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports